























import {Component, Prop, Vue} from 'vue-property-decorator';
import {Base} from '@/models/base';

@Component
export default class List extends Vue {
  @Prop()
  private items!: Base[];

  @Prop()
  private origin!: string;
}
